export const graphPromoteInstallmentsConfiguration = {
  minimumPrice: 75,
  numberOfInstallments: 3,
}
